import { ParsedQuery } from 'query-string';
import { useHash, Transformer as HashTransformer } from './use-hash';
import { TaskDrawerTab } from './use-navigate-to-task';

type Show = ['show'];
type Invalid = ['invalid'];
export type NewApprovalState = Show | Invalid;

const newApprovalTransformer: HashTransformer<NewApprovalState> = {
  from: (parsed) => {
    const tab = parsed.task_drawer_tab as TaskDrawerTab | undefined;
    const newApproval = parsed.show_new_approval as 'true' | undefined;

    switch (tab) {
      case TaskDrawerTab.Approvals:
        return newApproval === 'true' ? ['show'] : ['invalid'];
      case TaskDrawerTab.Conversations:
      default:
        return ['invalid'];
    }
  },
  to: (params): ParsedQuery => {
    switch (params[0]) {
      case 'show':
        return {
          show_new_approval: 'true',
        };
      default:
        return { show_new_approval: null };
    }
  },
};

export const useRequestTaskApproval = (): [NewApprovalState] => {
  const [params] = useHash(newApprovalTransformer);

  return [params];
};
